import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    padding: theme.spacings.md,
  },
  bodyText: {
    fontSize: theme.fontSizes.xl,
    marginBottom: theme.spacings.sm,
  },
  bold: {
    fontWeight: '600',
  },
  inputWrapper: {
    width: '100%',
    height: 56,
  },
  input: {
    width: '50%',
    height: '100%',
    borderWidth: 1,
    borderRadius: theme.borderRadii.md,
    borderColor: theme.colors.grey,
    backgroundColor: theme.colors.grey,
    paddingHorizontal: theme.spacings.sm,
    fontSize: theme.fontSizes.lg,
    textAlign: 'center',
  },
});
